import React from 'react';
import PicturesWall from '../add/pictures/pictures-wall';
import { Switch, Input, Button, Popconfirm, message } from 'antd';
import { getAttachmentsIds } from '../add/add-agenda';
import ActivityService from '../../../services/activity.service';

class FinishActivity extends React.Component {
  wallOfPictures = React.createRef();

  state = {
    final_observation: "",
    status: 3
  }

  finishIt = async () => {
    const { fileList } = this.wallOfPictures.current.state;
    const { activity, onDone } = this.props;
    const { final_observation, status } = this.state;
    const attachments = getAttachmentsIds(fileList);
    const data = {
      final_observation,
      status,
      attachments
    };
    try {
      const result = await ActivityService.finishActivity(activity.id, data);
      onDone(result);
      message.success("Actividad finalizada");
    } catch (error) {
      message.error("Ha ocurrido un error al finalizar la actividad");
    }
    
    
  }

  handleObservationChange = (result) => {
    this.setState({ final_observation: result.target.value });
  }

  handleSwitchChange = (result) => {
    this.setState({ status: result ? 2 : 3 });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h3>¿La actividad se realizó?</h3>
        <br />
        <Switch onChange={this.handleSwitchChange} checkedChildren="Si" unCheckedChildren="No" title="¿La actividad se realizó?" />
        <br />
        <Input.TextArea onChange={this.handleObservationChange} placeholder="Observaciones (opcional)" rows={10}>
        </Input.TextArea>
        <br />
        <PicturesWall ref={this.wallOfPictures} className="pic-wall" />
        <br />
        <Popconfirm title="¿Dar por terminada esta actividad?" onConfirm={this.finishIt}>
          <Button type="primary">Finalizar Actividad</Button>
        </Popconfirm>
      </div>
    );
  }
}

export default FinishActivity;